module.exports = __webpack_public_path__ + "img/floor.ebfa5911.svg";